import { useEffect } from 'react';

const useScrollToHash = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1); // remove the #
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' }); // or 'auto'
      }
    }
  }, []);

  return null;
};

export default useScrollToHash;
